export const NO_DATA_PLACEHOLDER = 'N/A'

export const MAX_UNITS_PER_CLASS = 5

export const MSP_GRADES_MAP = {
  6: 6,
  7: 7,
  8: 8,
}

export const K8_GRAPH_ENUM_TO_GRADE_NAME_MAP = {
  gradek: 'Kindergarten',
  grade1: 'Grade 1',
  grade2: 'Grade 2',
  grade3: 'Grade 3',
  grade4: 'Grade 4',
  grade5: 'Grade 5',
  grade6: 'Grade 6',
  grade7: 'Grade 7',
  grade8: 'Grade 8',
}

export const K8_GRADE_KEY_TO_GRAPH_ENUM = {
  k: 'gradek',
  1: 'grade1',
  2: 'grade2',
  3: 'grade3',
  4: 'grade4',
  5: 'grade5',
  6: 'grade6',
  7: 'grade7',
  8: 'grade8',
}

export const REPORTING_UNIT_SUMMARY_TO_LEARN_GRADES = {
  K: 'grade-k',
  '1': 'grade-1',
  '2': 'grade-2',
  '3': 'grade-3',
  '4': 'grade-4',
  '5': 'grade-5',
  '6': 'grade-6',
  '7': 'grade-7',
  '8': 'grade-8',
  k2t2: 'tier2-k2',
  '35t2': 'tier2-35',
  '68t2': 'tier2-68',
  dwbk: 'grade-dwb-k',
  dwb1: 'grade-dwb-1',
  dwb2: 'grade-dwb-2',
  dwb3: 'grade-dwb-3',
  dwb4: 'grade-dwb-4',
  dwb5: 'grade-dwb-5',
  dwb6: 'grade-dwb-6',
  dwb7: 'grade-dwb-7',
  dwb8: 'grade-dwb-8',
  dwb9: 'grade-dwb-9',
  dwb10: 'grade-dwb-10',
  dwb11: 'grade-dwb-11',
  dwb12: 'grade-dwb-12',
}

export const SORTED_GRADE_IDX = {
  'grade-k': 0,
  'grade-1': 1,
  'grade-2': 2,
  'grade-3': 3,
  'grade-4': 4,
  'grade-5': 5,
  'grade-6': 6,
  'grade-7': 7,
  'grade-8': 8,
  'tier2-k2': 9,
  'tier2-35': 10,
  'tier2-68': 11,
  'grade-dwb-k': 0,
  'grade-dwb-1': 1,
  'grade-dwb-2': 2,
  'grade-dwb-3': 3,
  'grade-dwb-4': 4,
  'grade-dwb-5': 5,
  'grade-dwb-6': 6,
  'grade-dwb-7': 7,
  'grade-dwb-8': 8,
  'grade-dwb-9': 9,
  'grade-dwb-10': 10,
  'grade-dwb-11': 11,
  'grade-dwb-12': 12,
}

// Tier2 Grade Band Keys - Single source of truth
// Used for URL routing, API mapping, and type safety
export const TIER2_GRADE_BAND_KEYS = {
  K_2: 'k-2',
  THREE_5: '3-5',
  SIX_8: '6-8',
}

// Tier2 Grade Band Display Labels
// Used for UI display (tabs, headers, etc.)
export const GRADE_BANDS = [
  {
    text: 'Grades K-2',
    url: TIER2_GRADE_BAND_KEYS.K_2,
  },
  {
    text: 'Grades 3-5',
    url: TIER2_GRADE_BAND_KEYS.THREE_5,
  },
  {
    text: 'Grades 6-8',
    url: TIER2_GRADE_BAND_KEYS.SIX_8,
  },
]

// Sort Order Constants
// Used for sorting data in ascending or descending order
export const ORDER_BY = {
  ASC: 'asc',
  DESC: 'desc',
}

// Tier2 Dashboard Sort Keys
// Maps sort key constants to their string values used in sortConfig
export const TIER2_DASHBOARD_SORT_KEYS = {
  SCHOOLS: 'schools',
  SMALL_GROUPS_CREATED: 'smallGroupsCreated',
  LESSONS_COMPLETED: 'lessonsCompleted',
  K_2: 'k-2',
  THREE_5: '3-5',
  SIX_8: '6-8',
}

// Tier2 Small Group Status
// Display values for small group active/hidden status
export const TIER2_SMALL_GROUP_STATUS = {
  ACTIVE: 'Active',
  HIDDEN: 'Hidden',
}

// Tier2 Lesson Completion Sort Keys
// Maps sort key constants to their string values used in sortConfig
export const TIER2_LESSON_COMPLETION_SORT_KEYS = {
  SMALL_GROUPS: 'smallGroups',
  STATUS: 'status',
  LESSONS_DONE: 'lessonsDone',
  FIRST_UNIT: 'firstUnit',
  SECOND_UNIT: 'secondUnit',
  THIRD_UNIT: 'thirdUnit',
  LAST_LOGGED_IN: 'lastLoggedIn',
}

// Table Pagination
// Default page size for table pagination
export const TABLE_PAGE_SIZE = 25

// Table URL Query Parameter Names
// Constants for table URL query parameter keys (shared across all table views)
export const TABLE_URL_PARAMS = {
  SITE_ID: 'site',
  SORT_KEY: 'sortKey',
  ORDER_BY: 'orderBy',
  CURRENT_PAGE: 'currentPage',
  PAGE_SIZE: 'pageSize',
  CLASS_INSTANCE: 'class',
}

// Tier2 Program-to-Courses Mapping
// Maps program and grade band to course arrays for API filtering
export const PROGRAM_TIER2_COURSES = {
  K8: {
    [TIER2_GRADE_BAND_KEYS.K_2]: ['GradesK2CurriculumTier2'],
    [TIER2_GRADE_BAND_KEYS.THREE_5]: ['Grades35CurriculumTier2'],
    [TIER2_GRADE_BAND_KEYS.SIX_8]: ['Grades68CurriculumTier2'],
  },
}

// Tier2 Course Name to Reporting API Grade Format Mapping
// Maps course names sent to API to grade values returned by API in UnitSummary/Units
// This complements REPORTING_UNIT_SUMMARY_TO_LEARN_GRADES by mapping course → API format
export const TIER2_COURSE_TO_REPORTING_GRADES = {
  GradesK2CurriculumTier2: 'k2t2',
  Grades35CurriculumTier2: '35t2',
  Grades68CurriculumTier2: '68t2',
}

// Get all tier2 courses for a program (for dashboard - fetches all grade bands)
export const getAllTier2CoursesForProgram = program => {
  const gradeBandCourses = PROGRAM_TIER2_COURSES[program] || {}
  return Object.values(gradeBandCourses).flat()
}
